import styled from "styled-components";

export const Form = styled.form`
  display: flex;
  gap: 12px;
  flex-direction: column;

  .input__hint {
    display: none;
  }
  .text-field {
    cursor: text;
  }
  .input__area {
    display: flex;
    align-items: center;
    position: relative;
    .input-container {
      position: static;
      width: 100%;
      padding-right: 38px;
      & > svg {
        top: 50%;
        right: 20px;
        transform: translateY(-50%);
      }
    }
  }

  input.input {
    pointer-events: all;
  }
  @media (min-width: 1023px) {
    flex-direction: row;
  }
`;
